<template>
  <v-snackbar
        class="grpr-snackbar"
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'bottom'"
        :vertical="mode === 'vertical'"
      >
        {{ text }}
        <v-btn
          color="primary"
          flat
          @click="toggleGDPR(true)"
        >
          Accept
        </v-btn>
      </v-snackbar>
</template>

<style lang="scss">
.grpr-snackbar {
  width: 100%;
  .v-snack__wrapper {
    // margin: 0;
    padding: 1em;
    width: 100%;
    max-width: 100%;
    max-height: auto;
    height: auto;
    .v-snack__content {
      width: 100%;
      height: auto;
    }
  }
}
</style>

<script>
export default {
  name: 'gdpr',
  data () {
    return {
      snackbar: false,
      y: 'top',
      x: null,
      mode: '',
      timeout: 0,
      text: 'We use cookies and other technologies to deliver personalized content on our websites and relevant advertising on other websites. Unless you change your preferences these technologies allow TD and our ad partners to better align ads with your banking goals.'
    }
  },
  mounted () {
    if (typeof (Storage) !== 'undefined') {
      const gdprResult = localStorage.getItem('GDPR') || false
      if (!gdprResult) {
        localStorage.setItem('GDPR', 'false')
        this.snackbar = true
      } else {
        if (gdprResult === 'false') {
          this.snackbar = true
        }
      }
    } else {
      throw new Error('Browser doesn\'t support local storage')
    }
  },
  methods: {
    toggleGDPR (gdpr) {
      localStorage.setItem('GDPR', 'true')
      this.snackbar = false
    }
  }
}
</script>
